<template src='./massDeclassifyModal.pug' lang='pug'></template>

<script>
import moment from 'moment'
import vSelect from 'vue-select'
import ConfirmModal from '../../modals/confirmModal/ConfirmModal'
import Modal from '../../modals/modal/Modal'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import { maskThousand } from '../../../utils/numberMasker.js'

export default {
  name: 'MassDeclassifyModal',

  components: {
    vSelect,
    ConfirmModal,
    Modal,
    ButtonPrimary
  },

  props: {
    id: {
      type: String,
      required: true
    },
    gridId: {
      type: String,
      required: true
    },
    listIdExt: {
      type: Array,
      required: true
    },
    listRowsD: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      columns: [],
      options: {
        columnsClasses: {},
        headings: {},
        filterable: false,
        perPageValues: [],
        perPage: 5,
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filter: null,
          filterPlaceholder: null
        },
        pagination: {},
        sortable: [],
        sortIcon: {
          is: ''
        }
      },
      items: [],
      idsContalancamento: [],
      idsContalancamentoDesclassificaveis: [],
      message: null,
      invalid: false,
      isLoadingData: false
    }
  },

  computed: {
    loggedUser () {
      return this.$store.getters.user
    },

    modalTitle () {
      return this.$t('desclassificacaoEmMassa.titulos.titulo')
    },

    modalSubtitle () {
      return this.$t('desclassificacaoEmMassa.titulos.subtitulo')
    },

    portletTable () {
      return `${this.$t('desclassificacaoEmMassa.titulos.portletTable')}: ${this.items.length}`
    },

    portletForm () {
      return `${this.$t('desclassificacaoEmMassa.titulos.portletForm')}: ${this.listIdExt.length - this.items.length}`
    },

    enableSave () {
      return this.items.length > 0 && this.items.length < 101
    }
  },

  watch: {
    listRowsD () {
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.showDataTableD()
      this.isLoadingData = false
    }
  },

  methods: {
    openModalConfirm () {
      $('#confirmDeclassifyMass').modal('show')
    },

    closeModalConfirm () {
      $('#confirmDeclassifyMass').modal('hide')
    },

    validateD () {
      this.closeModalConfirm()
      this.isLoadingData = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.desclassificarEmMassa()
          this.$nextTick(() => {
            this.$validator.reset()
          })
        } else {
          this.isLoadingData = false
        }
      })
    },

    desclassificarEmMassa () {
      this.items.forEach(item => { this.idsContalancamentoDesclassificaveis.push(item.IdLancamento) })
      let data = {
        idsContaLancamento: this.idsContalancamentoDesclassificaveis
      }
      this.idsContalancamentoDesclassificaveis = []
      this.$store.dispatch('declassifyBankMovementList', data)
        .then((response) => {
          this.$root.$refs.notification.success(response.message)
          this.isLoadingData = false
          $('#' + this.id).modal('hide')
        })
        .catch((error) => {
          this.isLoadingData = false
          this.$root.$refs.notification.error(error.message)
        })
    },

    trackCloseEvent () {
      this.$nextTick(() => {
        this.$validator.reset()
      })
      trackAnalyticsEvent(this, 'mass-declassify-modal', 'titlebar-close-click', this.id)
      $('#' + this.id).modal('hide')
    },

    showDataTableD () {
      this.idsContalancamento = this.listIdExt
      switch (this.gridId) {
        case 'ExtratoConta':
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt)
            .then(() => {
              this.mountDataTableBankStat()
            })
          break
      }
    },

    prepareList () {
      this.items = []
      this.listRowsD.forEach(item => {
        if (item['SituacaoConcil'] === 'A') {
          this.items.push({
            ID: item.IdLancamento,
            IdLancamento: item.IdLancamento,
            DsHistorico: item.DsHistorico,
            DtLanc: item.DtLanc ? moment.utc(item.DtLanc).format('l') : ' - ',
            Banco: item.Banco ? item.Banco : ' - ',
            NomeConta: item.NomeConta ? item.NomeConta : ' - ',
            Agencia: item.Agencia ? item.Agencia : ' - ',
            NrConta: item.NrConta ? item.NrConta : ' - ',
            Valor: maskThousand(item.Tipo === 'C' ? item.VlLancCred : item.VlLancDeb),
            CritClassif: item.CritClassif && item.CritClassif !== this.$t('extratoBancario.labels.naoClassificado') ? item.CritClassif : this.$t('desclassificacaoEmMassa.labels.classificadoManualmente')
          })
        }
      })
    },

    removeEntry (entry) {
      let index = -1
      this.items.forEach(item => {
        if (item.ID === entry.ID) {
          index = this.items.indexOf(item)
        }
      })
      if (index >= 0) {
        this.items.splice(index, 1)
      }
      switch (this.gridId) {
        case 'ExtratoConta':
          let indexCL = this.idsContalancamento.findIndex(item => item === entry.ID)
          if (indexCL >= 0) {
            this.idsContalancamento.splice(indexCL, 1)
          }
          break
      }
    },

    mountDataTableBankStat () {
      this.prepareList()
      this.columns = [
        'IdLancamento',
        'DtLanc',
        'Valor',
        'DsHistorico',
        'CritClassif',
        'Banco',
        'NomeConta',
        'Agencia',
        'NrConta',
        'acoes'
      ]
      this.options.headings = {
        IdLancamento: this.$t('desclassificacaoEmMassa.colunas.IdLancamento'),
        DtLanc: this.$t('desclassificacaoEmMassa.colunas.DtLanc'),
        Banco: this.$t('desclassificacaoEmMassa.colunas.Banco'),
        NomeConta: this.$t('desclassificacaoEmMassa.colunas.NomeConta'),
        Agencia: this.$t('desclassificacaoEmMassa.colunas.Agencia'),
        NrConta: this.$t('desclassificacaoEmMassa.colunas.NrConta'),
        Valor: this.$t('desclassificacaoEmMassa.colunas.Valor'),
        CritClassif: this.$t('desclassificacaoEmMassa.colunas.CritClassif'),
        DsHistorico: this.$t('desclassificacaoEmMassa.colunas.DsHistorico'),
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      }
      this.options.columnsClasses = {
        'IdLancamento': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Banco': 'col-1 limit-char',
        'NomeConta': 'col-1 limit-char',
        'Agencia': 'col-1 limit-char',
        'NrConta': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'CritClassif': 'col-1 limit-char',
        'acoes': 'col-1',
        'DsHistorico': 'col-1 limit-char'
      }
      this.options.orderBy = 'IdLancamento'
    }
  }
}
</script>

<style lang='css' scoped>
.declassify-title {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #fff;
  color: #1b3c65;
  padding: 0px 0px 5px 15px;
  font-size: 15px;
}

.form-control[disabled], fieldset[disabled] .form-control {
  cursor: not-allowed;
  font-weight: bold;
  color: #626262;
}
</style>



// WEBPACK FOOTER //
// MassDeclassifyModal.vue?5fe40db2